module.exports = __webpack_public_path__ + "img/gamma_background--small.be824868.png";